<template>
    <div class="grid-container">
        <div class="top-bar">
            <div class="top-bar-left">
                <router-link :to="{ path: '/' }">My SNKR Collection</router-link>
            </div>
            <div class="top-bar-right">
                <ul class="menu vertical medium-horizontal">
                    <li>
                        <router-link :to="{ path: '/' }">Home</router-link>
                    </li>
                    <li>
                        <router-link :to="{ path: '/sneakers' }">Sneakers</router-link>
                    </li>
                    <li v-if="userIsAuthenticated">
                        <router-link :to="{ path: '/collection' }">Collection</router-link>
                    </li>
                    <li v-if="userIsAuthenticated">
                        <router-link :to="{ path: '/wishlist' }">Wishlist</router-link>
                    </li>
                    <!--<li v-if="userIsAuthenticated">-->
                        <!--<router-link :to="{ path: '/stats' }">Stats</router-link>-->
                    <!--</li>-->
                    <!--<li v-if="userIsAuthenticated">-->
                        <!--<router-link :to="{ path: '/profile' }">Profile</router-link>-->
                    <!--</li>-->
                    <li>
                        <a v-if="userIsAuthenticated" class="logout" @click="onLogout">Log out</a>  
                        <router-link v-else :to="{ path: '/login' }" class="login">Log in</router-link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import firebase from 'firebase'

export default {
    name: 'main-menu',
    data () {
        return {
        }
    },
    methods: {
        onLogout: function () {
            this.$store.dispatch('logout')
        }
    },
    computed: {
        userIsAuthenticated () {
            return this.$store.getters.user !== null && this.$store.getters.user !== undefined
        }
    }
}
</script>



// WEBPACK FOOTER //
// MainMenu.vue?2fee11f6